"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const AvatarDoesNotExistError_1 = __importDefault(require("./errors/AvatarDoesNotExistError"));
class AvatarsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async pickAvatar(avatarId) {
        const url = `${this.url}/api/avatars`;
        const expectedResponses = [200, 422];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ avatarId })
        }, expectedResponses);
        if (response.status === 422) {
            throw new AvatarDoesNotExistError_1.default(avatarId);
        }
        return response.json;
    }
    async fetchAllAvatars() {
        const url = `${this.url}/api/avatars`;
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, expectedResponses);
        return response.json;
    }
}
exports.default = AvatarsServiceClient;
//# sourceMappingURL=AvatarsServiceClient.js.map